import { Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

const colors = {
  online: "#2e7d32", // Dark Green
  offline: "#424242", // Dark Grey
};

const OnlineOfflineLegend = ({ percentOnline = 0 }) => {
  return (
    <Stack direction="row" spacing={6}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="h8" fontWeight="500" sx={{ color: colors.online }}>
          {percentOnline}% Online
        </Typography>
      </Stack>
    </Stack>
  );
};

OnlineOfflineLegend.propTypes = {
  percentOnline: PropTypes.number,
  percentOffline: PropTypes.number,
};

export default OnlineOfflineLegend;
